export const googleLoginParams = {
  client_id:
    "181825529429-ku5v3avflclki5glqrq0dpretbc9cv37.apps.googleusercontent.com",
};
